import Vue from 'vue';

const state = ({
  me: {},
  admins: [],
});

const mutations = {
  setMe(state, me) {
    Vue.set(state, 'me', { ...state.me, ...me });
  },

  // Administrators
  setAdmins(state, admins) {
    state.admins = admins;
  },

  // Admin
  setAdmin(state, admin) {
    let index = state.admins.findIndex(a => a.id == admin.id);
    if (index >= 0) {
      Vue.set(state.admins, index, { ...state.admins[index], ...admin });
    } else {
      state.admins.push(admin);
    }
  },

  removeAdmin(state, id) {
    let index = state.admins.findIndex(a => a.id == id);
    if (index >= 0) {
      state.admins.splice(index, 1);
    }
  },
};

const getters = {
  unfinished(state) {
    if (!state.me || !state.me.id) {
      return true;
    }
    return !state.me.agreedToTermsAndConditions;
  },
};

const actions = {
  async registerUser(ctx, user) {
    try {
      await this.$axios.post('/Users', user);
      return true;
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },

  async validateAccount(ctx, payload) {
    try {
      await this.$axios.post('/Users/confirm-email', payload);
      return true;
    } catch (err) {
      console.log("Err");
      return false;
    }
  },

  /**
   * Return current logged in user
   */
  async getMe({ commit }) {
    try {
      const { data } = await this.$axios.get('/Users/me');

      if (data) {
        commit('setMe', data);
      }
      return true;
    } catch (err) {
      this.$fatalError(err);
      return false;
    }
  },

  /**
   * Update current logged in user
   */
  async updateUser({ getters, commit }, userData) {
    try {
      const response = await this.$axios.put('/Users/me', userData);
      if (response.data.success) {
        // this.$success('User profile has been successfully updated');
        if (getters['unfinished']) {
          commit('setMe', userData);
          return 'first';
        }
        commit('setMe', userData);
        return true;
      }
      this.$fatalError();
      return false;
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },

  async updatePassword(ctx, passwordData) {
    try {
      const response = await this.$axios.put('/Users/me/password', passwordData);
      if (response.data.success) {
        this.$success('Password has been successfully updated');
        return true;
      }
      this.$fatalError();
      return false;
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },

  // Get admins
  async getAdmins({ commit }) {
    try {
      const { data } = await this.$axios.get('admin/Users');
      if (data.success) {
        commit('setAdmins', data.users);
      } else {
        this.$warning('Something unexpected happened, please, refresh and try again.');
      }
      return true;
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },

  async createAdmin({ commit }, admin) {
    try {
      const { data } = await this.$axios.post('admin/user', admin);
      if (data.success) {
        admin.id = data.id;
        commit('setAdmin', admin);
        return true;
      } 
      this.$fatalError();
      return false;
      
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },

  async updateAdmin({ commit }, admin) {
    try {
      const { data } = await this.$axios.patch(`admin/user/${admin.id}`, admin);
      if (data.success) {
        commit('setAdmin', admin);
        return true;
      } 
      this.$fatalError();
      return false;
      
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },

  async disableAdmin({ commit }, row) {
    try {
      const { data } = await this.$axios.delete(`admin/user/${row.id}`);
      if (data.success) {
        row.isActive = false;
        commit('setAdmin', row);
        return true;
      } 
      this.$fatalError();
      return false;
      
    } catch (err) {
      this.$warning(`There was an error deactivating the admin account, please, try again.`);
      return false;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};